import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';

import { Language } from 'models/settings';
import { SUPPORTED_LANGUAGES } from 'constants/index';
import { setLang } from 'client/redux/settings';

import css from './LanguageDropdown.module.scss';
import { replaceLangInUrl } from './helpers';

type Props = {
  lang: Language;
};

const LanguageDropdown = ({ lang }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleChange = (newLang: Language) => {
    const { pathname } = location;

    const preloader = document.createElement('div');
    preloader.className = 'main-preloader';
    document.body.appendChild(preloader);

    dispatch(setLang(newLang));
    const newUrl = replaceLangInUrl(pathname, newLang);
    window.location.href = newUrl;
  };

  return (
    <div ref={ref} className={css.lgDropdown}>
      <button type="button" onClick={() => setOpen((o) => !o)} className={css.lgBtn}>
        <span>{lang.toUpperCase()}</span>
        <span className={css.arrowDropdown} />
      </button>

      {open && (
        <ul className={css.lgDropdownList}>
          {SUPPORTED_LANGUAGES.map((lg) => (
            <li key={lg}>
              <button
                type="button"
                onClick={() => {
                  handleChange(lg as Language);
                  setOpen(false);
                }}
                className={cn(css.item, lang === lg && css.active)}
              >
                <span>{lg.toUpperCase()}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
